export default {
  default: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/layouts/default.vue").then(m => m.default || m),
  iframe: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/layouts/iframe.vue").then(m => m.default || m),
  preview: () => import("/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/layouts/preview.vue").then(m => m.default || m)
}